module.exports = __webpack_public_path__ + "img/Gallery_3_14.17b26650.jpeg";